import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'faire_direct-faire_direct_for_current_location-action_category_error';

/**
 * Track this event if the faireDirectBrandsForVisitor data doesn't include the brand for the current FD page
 */
export function trackFaireDirectFaireDirectForCurrentLocationActionCategoryError(
  url: string,
  faireDirectBrandsForVisitorData2: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { url, faireDirectBrandsForVisitorData2 },
  });
}
